export default __webpack_public_path__ + "static/media/card2.bbd1a04c.png";